export enum ParticipationMode {
    INDIVIDUAL = "INDIVIDUEL",
    GROUP = "GROUPE",
}

export enum ParticipantStatus {
    ARCHI_STUDENT = "ETUDIANT EN ARCHITECTURE",
    ARCHI_GRADUATE = "ARCHITECTE DIPLOME",
    ENGINEERING_STUDENT = "ETUDIANT EN INGENIERIE",
    URBANISM_STUDENT = "ETUDIANT EN URBANISME",
}
export enum SocialPlatform {
    FACEBOOK = "FACEBOOK",
    INSTAGRAM = "INSTAGRAM",
    FACEBOOK_INSTAGRAM = "FACEBOOK_ET_INSTAGRAM",
}